import NotFoundPage from "../../not-found";
import DashboardPage from "../pages/dashboard";
import LeadsManagerPage from "../pages/leads-manager";
import AIRecommendationPage from "../pages/ai-recommendation";
import CompanySubmissionPage from "../pages/company-submission";
import MyCompanies from "../pages/my-companies";
import Dataset from "../pages/dataset";
import InvestorDetail from "../pages/investor-detail";
import Analytics from "../pages/analytics";
import MyProfile from "../pages/my-profile";
import PremiumLayout from "../../../components/premium-layout";
import Subscription from "../pages/subscription";
import PaymentCancel from "../pages/payment/cancel";
import PaymentSuccess from "../pages/payment/success";
import CompaniesOverview from "../pages/companies-overview";
import CompanyTasks from "../pages/company-tasks";
import OauthCallback from "../pages/oauth-callback";
import LeadForm from "../pages/leads-manager/pages/lead-form";
import AdminLayout from "../../../components/admin-layout";
import BlogForm from "../pages/blogs/form";
import Blogs from "../pages/blogs";
import OnboardingPage from "../pages/onboarding";

const routes = [
  {
    path: "/onboarding",
    exact: true,
    component: (props) => <OnboardingPage {...props} />,
  },
  {
    path: "/",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <CompaniesOverview {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/oauth/callback",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <OauthCallback {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/home",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <CompaniesOverview {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/analytics",
    exact: true,
    component: (props) => (
      <AdminLayout>
        <PremiumLayout>
          <Analytics {...props} />
        </PremiumLayout>
      </AdminLayout>
    ),
  },
  {
    path: "/blogs",
    exact: true,
    component: (props) => (
      <AdminLayout>
        <PremiumLayout>
          <Blogs {...props} />
        </PremiumLayout>
      </AdminLayout>
    ),
  },
  {
    path: "/blogs/create",
    exact: true,
    component: (props) => (
      <AdminLayout>
        <PremiumLayout>
          <BlogForm {...props} />
        </PremiumLayout>
      </AdminLayout>
    ),
  },
  {
    path: "/blogs/edit/:id",
    exact: true,
    component: (props) => (
      <AdminLayout>
        <PremiumLayout>
          <BlogForm {...props} />
        </PremiumLayout>
      </AdminLayout>
    ),
  },
  {
    path: "/leads-manager",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <LeadsManagerPage {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/leads-manager/create",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <LeadForm {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/leads-manager/edit/:id",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <LeadForm {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/ai-recommendation",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <AIRecommendationPage {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/company-submission",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <CompanySubmissionPage {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/companies",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <MyCompanies {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/company-detail",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <DashboardPage {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/company-tasks",
    exact: true,
    component: (props) => (
      <PremiumLayout>
        <CompanyTasks {...props} />
      </PremiumLayout>
    ),
  },
  {
    path: "/dataset",
    exact: true,
    component: (props) => <Dataset {...props} />,
  },
  {
    path: "/investors/:id",
    exact: true,
    component: (props) => <InvestorDetail {...props} />,
  },
  {
    path: "/my-profile",
    exact: true,
    component: (props) => <MyProfile {...props} />,
  },
  {
    path: "/subscription",
    exact: true,
    component: (props) => <Subscription {...props} />,
  },
  {
    path: "/payment-success",
    exact: true,
    component: (props) => <PaymentSuccess {...props} />,
  },
  {
    path: "/payment-canceled",
    exact: true,
    component: (props) => <PaymentCancel {...props} />,
  },
  {
    path: "*",
    component: () => <NotFoundPage />,
  },
];

export default routes;
